import React from "react";
import "./educationNew.css";
import projectsData from "../../data/projectsData";

const Education = () => {
  const educations = projectsData.education;

  return (
    <section className="experience-section" id="education">
      <h2 className="section-title">EDUCATION</h2>
      <p className="section-intro">
        Education background of Shantanu Basumatary, including MCA at NIT
        Warangal and a foundation in computer science.
      </p>
      <div className="experience-timeline">
        {educations.map((edu) => (
          <div key={edu.id} className="experience-item">
            <div className="experience-date">
              <div className="experience-year">{edu.year}</div>
              <div className="experience-month">{edu.month}</div>
            </div>
            <div className="experience-dot"></div>
            <div className="experience-content">
              <h3 className="experience-title">{edu.degree}</h3>
              <p className="experience-company">{edu.institution}</p>
              <p className="experience-description">{edu.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Education;
